import { apiSlice } from '../app/api/apiSlice';

export const venueApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({
    venue: builder.query({
      keepUnusedDataFor: 60,
      query: (query) => `venue/${query?query:""}`,
    }),
  })
})

export const { useVenueQuery } = venueApi;
